import {IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";

require('./temaMedBeskrivelse.scss');

export class TemaMedBeskrivelseBeskrivelse implements IController {
    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteTemaMedBeskrivelse', {
                bindings: {tema: '<'},
                controller: TemaMedBeskrivelseBeskrivelse.forInjisering(),
                template: require('./temaMedBeskrivelse.html')
            });
    }

    static forInjisering() {
        return [
            TemaMedBeskrivelseBeskrivelse
        ]
    }

    constructor() {
    }

    tema: l.TemaModell; //settes via bindings/$onChanges



    //hjelpemetoder

}
